<template>
  <b-container fluid style="margin-top:90px;">
    
    <b-card v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card>
    <b-card>
      <b-table striped outlined hover :fields="fields" :items="tenants">
        <template #cell(assumekey)="data" >
          <AssumeTenantBtn :TenantID="data.item.ID" :token="token" v-on:setData="setData" />
        </template>

        <template #cell(deletekey)="data" >
          <TenantDeleteBtn v-on:removeTenant="removeTenant" :TenantID="data.item.ID" :token="token" />
        </template>

        <template #cell(editkey)="data" >
          <EditTenantBtn variant="outline-info" :Tenant="data.item" v-on:EditTenant="EditTenant" />
        </template>
      </b-table>
    </b-card>

    <b-card class="mt-1">
      <b-form @submit="onSubmit">
        <b-form-group id="input-group-1" :label="$t('NEW_TENANT')" label-for="input-1">
          <b-form-input v-model="form.Name" type="text" required :placeholder="$t('ENT_TEN_NAME')"></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-input
            v-model="form.Postfix"
            type="text"
            required
            :placeholder="$t('ENT_TEN_SUFFIX')"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-input
            v-model="form.TeacherSeats"
            type="number"
            required
            :placeholder="$t('TEACHER_SEATS')"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-input
            v-model="form.StudentSeats"
            type="number"
            required
            :placeholder="$t('STUDENT_SEATS')"
          ></b-form-input>
        </b-form-group>
        
        <b-form-group :label="$t('LICENSE_BEGINS')" label-for="licenseBegins">
          <b-form-input
              v-model="form.LicenseBegins"
              type="date"
              id="licenseBegins"
              required
              :placeholder="$t('LICENSE_BEGINS')"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('LICENSE_EXPIRES')" label-for="licenseExpires">
          <b-form-input
            v-model="form.LicenseExpires"
            type="date"
            id="licenseExpires"
            required
            :placeholder="$t('LICENSE_EXPIRES')"
          ></b-form-input>
        </b-form-group>

        <div class="d-flex align-items-center">
          <b-button type="submit" variant="primary">{{$t("CREATE")}}</b-button>
        </div>
      </b-form>
    </b-card>
    <EditTenantModal :Tenant="EditingTenant" :token="token" />
  </b-container>
</template>
<script>
import { ajaxGet, ajaxPost } from "../../ajax";
import TenantDeleteBtn from "./TenantDeleteBtn";
import AssumeTenantBtn from './AssumeTenantBtn';
import EditTenantBtn from './EditTenantBtn';
import EditTenantModal from './EditTenantModal';
import {apiUrl} from "@/main";

export default {
  components: {
    TenantDeleteBtn,
    AssumeTenantBtn,
    EditTenantModal,
    EditTenantBtn
  },
  data: function() {
    return {
      fields: [
        { key: "ID", label: this.$t("ID"),thClass: 'd-none', tdClass: 'd-none'},
        { key: "Name", label: this.$t("NAME")},
        { key: "Postfix", label: this.$t("SUFFIX")},
        { key: "TeacherSeats", label: this.$t("TEACHER_SEATS")},
        { key: "StudentSeats", label: this.$t("STUDENT_SEATS")},
        { key: "LicenseBegins", label: this.$t("LICENSE_BEGINS")},
        { key: "LicenseExpires", label: this.$t("LICENSE_EXPIRES")},
        { key: "editkey", label: "Edit"},
        { key: "assumekey", label: "Assume"},
        { key: "deletekey", label: "Delete" }
      ],
      tenants: [],
      loading: false,
      form: {
        Name: "",
        Postfix: "",
        TeacherSeats: null,
        StudentSeats: null,
        LicenseExpires: null,
        LicenseBegins:null
      },
      EditingTenant: {
        Name: "",
        Postfix: "",
        TeacherSeats: null,
        StudentSeats: null,
        LicenseBegins: null,
        LicenseExpires: null
      },
      modalShow: false
    };
  },
  props: ["token"],
  mounted: function() {
    this.loading = true;

    var admPnl = this;

    setTimeout(function() {
      ajaxGet(
        apiUrl() +"/tenants",
        admPnl.dataSuccessLoad,
        admPnl.dataError,
        admPnl.token
      );
    }, 50);

    //window.alert(this.token.token);
  },
  methods: {
    dataSuccessLoad: function(res) {
      this.tenants = res;
      this.loading = false;
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }

      this.loading = false;
    },
    setData : function(token) {
      this.$emit('setData', token);
    },
    EditTenant : function(tenant) {
      this.EditingTenant = tenant;
      this.$bvModal.show('editTenantModal');
    },
    onSubmit: function(event) {
      event.preventDefault();

      if(this.form.TeacherSeats == null || this.form.TeacherSeats < 1) {
        this.$bvModal.msgBoxOk("There must be at least one teacher seat!");
        return;
      }

      if(this.form.StudentSeats == null || this.form.StudentSeats < 1) {
        this.$bvModal.msgBoxOk("There must be at least one student seat!");
        return;
      }

      if(this.form.LicenseBegins == null){
        this.$bvModal.msgBoxOk("There must be a license begin date!");
        return;
      }
      
      if(this.form.LicenseExpires == null) {
        this.$bvModal.msgBoxOk("There must be license expiration date!");
        return;
      }


      this.loading = true;

      ajaxPost(
        apiUrl() +"/tenants",
        this.form,
        this.createTenantSuccess,
        this.dataError,
        this.token
      );
    },
    createTenantSuccess: function(res) {
      this.tenants.push({
        ID: res.insertId,
        Name: this.form.Name,
        Postfix: this.form.Postfix,
        TeacherSeats: this.form.TeacherSeats,
        StudentSeats: this.form.StudentSeats,
        LicenseBegins:this.form.LicenseBegins,
        LicenseExpires: this.form.LicenseExpires
      });

      this.$bvToast.toast('Tenant "' + this.form.Name + '" was created!', { autoHideDelay: 5000, appendToast: true});

      this.form = {
        Name: "",
        Postfix: "",
        TeacherSeats: null,
        StudentSeats: null,
        LicenseBegins: null,
        LicenseExpires: null
      };

      this.loading = false;
    },
    removeTenant: function(tenantID) {
      for (var a = 0; a < this.tenants.length; a++) {
        if (this.tenants[a].ID == tenantID) {

          this.$bvToast.toast('Tenant "' + this.tenants[a].Name + '" was deleted!', { autoHideDelay: 5000, appendToast: true});
          this.tenants.splice(a, 1);
          break;
        }
      }
    }
  }
};
</script>